import React, { useState } from 'react';
import classnames from 'classnames';

import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowRightOutlinedIcon from '@mui/icons-material/ArrowRightOutlined';
import i18n from 'i18next';
import { registerDecoration } from 'core/forms';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import getDynamicVariablesSchema from '../schemas/getDynamicVariablesSchema';

import styles from '../styles/formDecorationDynamicVariables.module.scss';

const FormDecorationDynamicVariables = () => {
  const [isExpanded, setisExpanded] = useState(false);
  const text = i18n.t('dynamic-variables');

  const handleClick = () => {
    setisExpanded(!isExpanded);
  };

  return (
    <div className={styles.container}>
      <Button
        aria-expanded={isExpanded}
        icon={isExpanded ? <ArrowDropDownOutlinedIcon /> : <ArrowRightOutlinedIcon />}
        onClick={handleClick}
        size="small"
        text={text}
        variant="outlined"
      />
      <div className={classnames(styles.element, isExpanded && styles.isExpanded)}>
        <div className={styles.header}>
          <Typo color="secondary" variant="s02" weight="medium">
            {text}
          </Typo>
          <Typo color="secondary" variant="s01">
            {i18n.t('dynamic-variables-body')}
          </Typo>
        </div>
        <div className={styles.body}>
          {getDynamicVariablesSchema().map(({ title, variables }) => (
            <div className={styles.section} key={title}>
              <Typo variant="s01" weight="medium">
                {title}
              </Typo>
              <ul className={styles.list}>
                {variables.map((variable) => (
                  <li key={variable}>
                    <Typo color="secondary" variant="s01">
                      {`@${variable}@`}
                    </Typo>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

registerDecoration('DynamicVariables', FormDecorationDynamicVariables);

export default FormDecorationDynamicVariables;
